module.exports = __webpack_public_path__ + "static/media/about-bg.8d0f44c6.webp";